const ReportAccountingTable = ({ data }) => {

  const tableStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    textAlign: "center",
    width: "80%"
  };

  const headerStyle = {
    fontSize: "1.5rem",
    color: "#fff",
    backgroundColor: "#235F7B"
  };

  const cellStyle = {
    fontSize: "1.5rem",
    border: "1px solid #000",
    borderLeft: "0"
  };

  const cellStyleFirstElement = {
    borderLeft: "1px solid #000"
  }

  const initialValue = { AAR: 0, AMR: 0, MAR: 0, MMR: 0, Manuale: 0 };
  let dataFormatted = data.reduce((accumulator, currValue) => ({ ...accumulator, [currValue.tipoInserimento]: currValue.countPratiche }), initialValue);
  dataFormatted = { ...dataFormatted, Manuale: Number(dataFormatted.MAR) + Number(dataFormatted.MMR) }

  return (
    <>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div style={tableStyle}>
          <div style={headerStyle}>Automatica Alto Rischio</div>
          <div style={headerStyle}>Automatica Medio Rischio</div>
          <div style={headerStyle}>Manuale</div>
          <div style={{ ...cellStyle, ...cellStyleFirstElement }}>{dataFormatted.AAR}</div>
          <div style={cellStyle}>{dataFormatted.AMR}</div>
          <div style={cellStyle}>{dataFormatted.Manuale}</div>
        </div>
      </div>
    </>
  );
}
export default ReportAccountingTable;